<script setup>
import VueSelect from "vue-select";

const props = defineProps({
  value: {
    type: [String,Array],
    required: false,
    default: ''
  },
  multiple: {
    type: Boolean,
    required: false,
    default: false
  },
  options: {
    type: Array,
    required: false,
    default: []
  },
  label: {
    type: String,
    required: true
  },
  handleUpdateValue: {
    type: Function,
    required: false,
    default: null,
  },
  reductionFunction: {
    type: Function,
    required: false,
    default: (option) => option
  }
})

const emits = defineEmits(['input']) // temp
const handleLocalUpdate = (value) => {
  if (props.handleUpdateValue !== null) {
    return props.handleUpdateValue(value)
  } else {
    console.log('doing default input from vue 2')
    emits("input", value)
  }
}
</script>
<template>
  <VueSelect
    :multiple="props.multiple"
    :modelValue="props.value"
    @update:modelValue="handleLocalUpdate"
    :options="props.options"
    :label="props.label"
    :reduce="type => type.id"
  />
</template>
